import { HELLO_EMAIL, PARTNER_EMAIL, SOCIALS, type SocialId } from '../../lib/content'
import { Logo } from '../ui/Logo'
import { SmartLink } from '../ui/SmartLink'
import { EmailCopy } from '../ui/EmailCopy'
import './Footer.css'

const YEAR = new Date().getFullYear()

function SocialIcon({ id }: { id: SocialId }) {
  if (id === 'instagram') return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.9"><rect x="3" y="3" width="18" height="18" rx="5.2" /><circle cx="12" cy="12" r="4.1" /><circle cx="17.4" cy="6.6" r="1.1" fill="currentColor" stroke="none" /></svg>
  )
  if (id === 'x') return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M17.75 3h3.07l-6.7 7.66L22 21h-6.17l-4.83-6.32L5.47 21H2.4l7.17-8.2L2 3h6.33l4.37 5.78L17.75 3zm-1.08 16.2h1.7L7.4 4.73H5.58l11.09 14.47z" /></svg>
  )
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><path d="M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3zM9.5 9h3.8v1.7h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.5c0-1.3-.02-3-1.83-3-1.84 0-2.12 1.43-2.12 2.9V21h-4z" /></svg>
  )
}

const COLS = [
  { h: 'Product', links: [['Explore the map', '/#explore'], ['Host a plan', '/#host'], ['Join the waitlist', '/#waitlist']] },
  { h: 'Business', links: [['Advertise on mauj', '/advertise'], ['Ad formats', '/advertise#formats'], ['Partner API', '/advertise#faq']] },
  { h: 'Trust', links: [['Safety', '/#safety'], ['Privacy policy', '/privacy'], ['Terms of use', '/terms']] },
]

export function Footer() {
  return (
    <footer>
      <div className="wrap">
        <div className="fgrid glass">
          <div><Logo /><p>Plans that people near you made, on one map. No feeds, no follower counts.</p>
            <ul className="socials" aria-label="mauj on social media">
              {SOCIALS.map((x) => (
                <li key={x.id}><a href={x.href} target="_blank" rel="noopener noreferrer" aria-label={`mauj on ${x.label} (${x.handle}), opens in a new tab`} title={`${x.label} ${x.handle}`}><SocialIcon id={x.id} /></a></li>
              ))}
            </ul>
          </div>
          {COLS.map((c) => (
            <div key={c.h}><h4>{c.h}</h4><ul>{c.links.map(([t, href]) => <li key={t}><SmartLink to={href}>{t}</SmartLink></li>)}</ul></div>
          ))}
          <div><h4>Contact</h4><ul><li><EmailCopy email={HELLO_EMAIL} className="bare" /></li><li><EmailCopy email={PARTNER_EMAIL} className="bare" /></li></ul></div>
        </div>
        <div className="footer-legal"><span>© {YEAR} mauj</span><span>Made in India, for nights out.</span></div>
      </div>
    </footer>
  )
}
